export const shareOnFB = (url: string, dogName: string) =>
	process.env.GATSBY_IS_IE === "true"
		? `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${`Say hi to ${dogName}. Could you give this @DogsTrust rescue dog a fur-ever home?`}`
		: `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${`Say hi to ${dogName}. Could you give this @DogsTrust rescue dog a fur-ever home?`}`;

export const shareOnX = (url: string, dogName: string) =>
	process.env.GATSBY_IS_IE === "true"
		? `https://twitter.com/intent/tweet?url=${url}&via=DogsTrust_IE&text=${`Say hi to ${dogName}. Could you give this @DogsTrust_IE rescue dog a fur-ever home?`}`
		: `https://twitter.com/intent/tweet?url=${url}&via=DogsTrust&text=${`Say hi to ${dogName}. Could you give this @DogsTrust rescue dog a fur-ever home?`}`;

export const shareViaEmail = (
	url: string,
	dogName: string,
	dogBreed: string,
) =>
	process.env.GATSBY_IS_IE === "true"
		? `mailto:?subject=Say hi to rescue dog ${dogName}&body=I saw that ${dogName}, the ${dogBreed} is looking for a new home and thought of you. \n\n ${url}`
		: `mailto:?subject=Say hi to rescue dog ${dogName}&body=I saw that ${dogName}, the ${dogBreed} is looking for a new home and thought of you. \n\n ${url}`;

export const shareViaWhatsApp = (
	url: string,
	dogName: string,
	dogBreed: string,
) =>
	process.env.GATSBY_IS_IE === "true"
		? `https://wa.me/?text=I saw that ${dogName}, the ${dogBreed} is looking for a new home and thought of you: ${url}`
		: `https://wa.me/?text=I saw that ${dogName}, the ${dogBreed} is looking for a new home and thought of you: ${url}`;
